import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "dropclaim_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg?.replace("Value error, ", "")).join(", ");
  return d || fallback;
};

export const CURRENCY = "$";
export const money = (n) => `${CURRENCY}${Number(n || 0).toFixed(2)}`;
export const won = (n) => (n || n === 0 ? `₩${Math.round(Number(n)).toLocaleString("en-US")}` : "");

export const fmtKST = (iso) =>
  iso
    ? `${new Date(iso).toLocaleString("en-US", { timeZone: "Asia/Seoul", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" })} KST`
    : "";
export const fmtDay = (ymd) =>
  ymd ? new Date(`${ymd}T12:00:00+09:00`).toLocaleDateString("en-US", { timeZone: "Asia/Seoul", weekday: "short", month: "short", day: "numeric", year: "numeric" }) : "";
export const fancallWhen = (r) => (r.fancall_datetime ? fmtKST(r.fancall_datetime) : r.event_date ? `Event ${fmtDay(r.event_date)}` : "");
export const toKSTInput = (iso) => (iso ? iso.slice(0, 16) : "");
export const fromKSTInput = (v) => (v ? `${v}:00+09:00` : "");
export const isPast = (iso) => !!iso && new Date(iso) < new Date();
export const previewUrl = (d) => (d.preview_version ? `${API}/drops/${d.id}/preview?v=${encodeURIComponent(d.preview_version)}` : null);
export const bonusPreviewUrl = (d) => (d.bonus_preview_version ? `${API}/drops/${d.id}/bonus-preview?v=${encodeURIComponent(d.bonus_preview_version)}` : null);
export const itemPhotoUrl = (sdId, it) => `${API}/special-drops/${sdId}/items/${it.id}/photo?v=${encodeURIComponent(it.photo_version || "")}`;
export const FILL_RULES = {
  "6/8": { label: "6/8", desc: "6 of the 8 members must be filled before a new set opens" },
  "7/8": { label: "7/8", desc: "7 of the 8 members must be filled before a new set opens" },
  fancall: { label: "Fancall Round", desc: "All 8 must be filled for a new set to open" },
  unit: { label: "Unit 4/4", desc: "All 4 units must be claimed before a new set opens, and a set only goes through once it's 4/4. Claims are first come for everyone", hidden: true },
};

export const MEMBERS = ["Hongjoong", "Seonghwa", "Yunho", "Yeosang", "San", "Mingi", "Wooyoung", "Jongho"];
export const ITEM_TYPES = ["Merch", "Snapism", "Washi Tape"];
export const DROP_STATUSES = [
  ["open", "Open"],
  ["closed", "Closed"],
  ["ordered", "Ordered"],
  ["arrived_pastelfix", "Arrived to PastelFix"],
  ["sorting", "Sorting"],
  ["shipped_areku", "Shipped to Areku"],
  ["arrived_areku", "Arrived to Areku"],
  ["packing", "Packing Up"],
  ["collecting_initials", "Collecting Initials"],
];
export const PAY_METHODS = {
  ThePastelFix: ["Wise: @consueloalejandrag", "Zelle: thepastelfix@gmail.com", "PayPal F&F: @arekucos", "K Bank: Message for Info"],
  ArekuTrades: ["Wise: @yanitzas1", "PayPal F&F: @arekucos", "Venmo: @arekutrades"],
};
export const TIERS = ["GoM", "Fixed", "Soft", "Open"];
export const tierRank = (t) => { const i = TIERS.indexOf(t); return i < 0 ? 3 : i; };

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
